exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/gas/gasArticles/newgasarticles.component.scss
// module id = ../../../../../src/app/gas/gasArticles/newgasarticles.component.scss
// module chunks = 0